import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useEffect } from 'react';
import '../styles/dark-mode.css';
;
const ThemeContext = createContext(undefined);
export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
export const ThemeProvider = ({ children }) => {
    const [darkMode, setDarkMode] = useState(() => {
        const saved = localStorage.getItem('darkMode');
        return saved ? JSON.parse(saved) : false;
    });
    const toggleDarkMode = () => {
        setDarkMode((prev) => {
            const newMode = !prev;
            localStorage.setItem('darkMode', JSON.stringify(newMode));
            return newMode;
        });
    };
    useEffect(() => {
        const body = document.body;
        body.classList.add('theme-transition');
        if (darkMode) {
            body.classList.add('dark-mode');
        }
        else {
            body.classList.remove('dark-mode');
        }
        const timer = setTimeout(() => body.classList.remove('theme-transition'), 300);
        return () => clearTimeout(timer);
    }, [darkMode]);
    return (_jsx(ThemeContext.Provider, { value: { darkMode, toggleDarkMode }, children: children }));
};
